import { memo } from "react";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";

interface TaskSheetHeaderProps {
  onClose: () => void;
  title?: string;
  id?: string;
}

export const TaskSheetHeader = memo((props: TaskSheetHeaderProps) => {
  const { title = "", onClose, ...rest } = props;
  return <FixaModalHeader closeBtnClick={onClose} title={title} {...rest} />;
});
